<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <v-input
                        :id="generateId(2)"
                        ref="idculturaerpInput"
                        v-model="tipocultura.idtipoculturaerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        :required="isUpdate"
                        :invalid="isUpdate && isNull(tipocultura.idtipoculturaerp)"
                        :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column">
                    <v-input
                        :id="generateId(1)"
                        ref="descricaoInput"
                        v-model="tipocultura.descricao"
                        :placeholder="'descricao-do-tipo-cultura-placeholder'"
                        :maxlength="30"
                        title="descricao"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="isNull(tipocultura.descricao)"
                        :required="true"
                        :disabled="cantEdit"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoCulturaService from '@/services/agro/CulturaService';
import TipoCulturaValidation from '@/services/validations/TipoCulturaValidation';
import Message from '@/models/Message';

export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('TIPOCULTURA'),
            service: new TipoCulturaService(this.$http, this.$router),
            validation: new TipoCulturaValidation(this.msgs),
            msgs: [],
            isLoading: false,
            isSaving: false,
            permissao: false,
            cantEdit: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,

            tipocultura: {
                idtipocultura: null,
                idtipoculturaerp: null,
                descricao: null,
                situacao: null,
                replicapda: null,
            },

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
            originalIdErp: ''
        };
    },
    watch: {
        tipocultura: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    created() {
        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-cultura');
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-cultura');
        }

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cultura' },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-dados-cadastrais-' + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;

            this.service
                .find(this.$route.params.id, this.abrev)
                .then((body) => {
                    this.tipocultura.idtipocultura = body.content.idtipocultura;
                    this.tipocultura.idtipoculturaerp = body.content.idtipoculturaerp;
                    this.tipocultura.descricao = body.content.descricao;
                    this.tipocultura.situacao = body.content.situacao;
                    this.tipocultura.replicapda = body.content.replicapda;
                    this.originalIdErp = this.tipocultura.idtipoculturaerp;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    setTimeout(() => {
                        this.$emit('isChanged', false);
                    }, 300);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                    this.$emit('descricao', this.tipocultura.descricao);
                });
        },
        save() {
            this.isLoading = true;
            let tempTipocultura = Object.assign({}, this.tipocultura);
            if (this.validation.validate(tempTipocultura, this.$refs)) {
                if(this.isPrefixSovisInIdErpInvalid(this.tipocultura.idtipoculturaerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
                    
                    this.isLoading = false;

                    return this.$root.showMessage('alert', message, true);
                }

                tempTipocultura = this.mapTosave(tempTipocultura);
                this.isSaving = true;
                this.service
                    .save(tempTipocultura, this.abrev)
                    .then((value) => {
                        if (value.message == null && value.status == 200) {
                            let msg =
                                this.tipocultura.idtipocultura != null
                                    ? 'msg-tipocultura-edita'
                                    : 'msg-tipocultura-salva';

                            this.msgs.push(new Message('success', msg, true));

                            this.$emit('isChanged', false);

                            this.tipocultura = value.content;
                            this.$emit('redirect', this.tipocultura.idtipocultura);
                        } else {
                            if (this.$te(value.message)) {
                                if (value.message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(value.message, { n: tempTipocultura.idtipoculturaerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else if (value.message) {
                                    this.msgs.push(new Message('alert', value.message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body && e.body.status == 409) {
                            this.msgs.push(new Message('alert', e.body.message, true));
                        } else {
                            console.error('Erro ao salvar: ' + e);
                            this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
